import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {CommonModalTemplatesEnum, CommonModalTemplatesInterfaces, ICommonModalBase} from '../modals/all-modals-config';


@Injectable({
  providedIn: 'root'
})
export class CommonModalService {
  public showModal: boolean = false;
  public showModalTemplateName: CommonModalTemplatesEnum = null;
  public showCloseBtn: boolean = true;
  private modals = new BehaviorSubject<any>(null);
  private modalsObs = this.modals.asObservable();
  private initializedModalsList = {};
  public disableClose: boolean = false;

  public getInitializedModalsList() {
    return this.initializedModalsList;
  }

  public getModalsObs<K>(): Observable<K> {
    return this.modalsObs;
  }

  public addToInitializedModalsList(
    data: CommonModalTemplatesInterfaces
  ): void {
    this.initializedModalsList[data.templateName] = data;
  }

  public isTemplateDefined(
    templateName: CommonModalTemplatesEnum
  ): boolean {
    return !!this.initializedModalsList[templateName];
  }

  public setData<T extends ICommonModalBase>(
    _data: T
  ): void {
    this.modals.next(_data);
    this.showModal = true;
    this.showModalTemplateName = _data.templateName;
    typeof(_data.showCloseBtn) !== 'undefined' ? this.showCloseBtn = _data.showCloseBtn : null;
    typeof(_data.disableClose) !== 'undefined' ? this.disableClose = _data.disableClose : null;
  }

  public closeAllModals(): void {
    this.showModal = false;
  }

  public destroyAllModals(): void {
    this.showModalTemplateName = null;
  }

  public sendRedirect(
    url: string
  ): void {
    window.location.href = url;
  }
}


